// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","caption":"_1dJD2pSCq2-UhXWE_3mRfd","errorRed":"#ff2a2a","button":"OHVRT3GtSaobq2hZhH8Xs","successText":"qoKOC2VL4awu6MPKdfuHK _2lYHSCAcM6vA2s-47YYZeS","input":"_2JztLcUAaKvft-pVO2yg7C","errorMessage":"_3qeiQgU_G9ioY5m2nsB1UF _1dJD2pSCq2-UhXWE_3mRfd"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/change-password/data-form/DataForm.css
// module id = 684
// module chunks = 0